import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { COMMON_NAMESPACE, sharedI18nResources } from '@consumer/shared/i18n'

export const defaultNS = COMMON_NAMESPACE
export const resources = sharedI18nResources

// `initImmediate: false` + bundled resources make init fully synchronous, so
// translations are guaranteed ready before the React tree first renders
// (main.tsx imports this module before calling createRoot().render()).
i18n.use(initReactI18next).init({
  resources,
  defaultNS,
  ns: [COMMON_NAMESPACE],
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    // React already escapes interpolated values.
    escapeValue: false,
  },
  returnNull: false,
  initImmediate: false,
})

export default i18n
